import _ from "lodash";
import moment from "moment";
import { Fragment, useCallback, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { PopupContext } from "./PopupContext";
import { PopupStyled } from "./PopupStyled";
import { IPopupProviderMessage } from "./PopupProvider.t";

interface IPopupProviderProps {
    children: JSX.Element
}

const PopupProvider = ({ children }: IPopupProviderProps) => {
    const [messages, setMessages] = useState<IPopupProviderMessage[]>([]);

    useEffect(() => {
        const timer = setInterval(() => {
            const newMessages = _.filter(messages, item => moment(item.close) > moment());
            if (newMessages.length !== messages.length) setMessages(newMessages);
        }, 300);
        return () => {
            clearInterval(timer);
        }
    }, [messages]);

    const hideMessage = useCallback((uuid) => {
        setMessages(messages => _.filter(messages, item => item.uuid !== uuid));
    }, []);

    const addToQueue = useCallback((params) => {
        const uuid = uuidv4();
        setMessages((messages) => ([] as IPopupProviderMessage[]).concat(messages).concat([
            {
                uuid,
                close: moment().add(5, 's').toISOString(),
                ...params,
            }
        ]));
    }, []);

    const infoPopup = useCallback((params) => {
        addToQueue({
            title: params.title,
            text: params.text,
            json: params.json,
        });
    }, [addToQueue]);

    const catchPopup = useCallback((error) => {
        if (error.response) error = error.response;
        addToQueue({
            variant: 'danger',
            title: error.status,
            text: error.data?.messageText || error.data?.messageCode || error.data?.message || error.statusText,
        });
    }, [addToQueue]);

    return <>
        <PopupContext.Provider value={{ catchPopup, infoPopup }}>
            <PopupStyled>
                {
                    messages.slice(-5).map(item => <Fragment key={item.uuid}>
                        <div onClick={() => hideMessage(item.uuid)}>
                            <Alert variant={item.variant || 'success'}>
                                {
                                    item.title && <h6>{item.title}</h6>
                                }
                                {
                                    !!item.json && <pre>{JSON.stringify(item.json, null, 2)}</pre>
                                }
                                {
                                    !!item.text && <div>{item.text}</div>
                                }
                            </Alert>
                        </div>
                    </Fragment>)
                }
            </PopupStyled>
            {children}
        </PopupContext.Provider>
    </>
}

export default PopupProvider;
